import { pipe } from 'lib/util'
import { modelComposition } from 'trait/composition'

const descriptor = 'model::notification'

export default pipe(
  modelComposition(descriptor),
)
